import { createAction, props } from '@ngrx/store';
import { Permission } from './permissions.model';
import { Role } from '../Roles/roles.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records permission',
    props<{ id: string }>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records permission success', 
    props<{ listData: Permission[], role: Role }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records permission failure', 
    props<{ error: string }>()
);


// Update Data
export const updateRecord = createAction(
    '[Data] Update record permission',
    props<{ id: string; updatedData: Permission }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record permission success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record permission failure',
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state permission',
);